//import { element } from "prop-types";
import { memo, useEffect } from "react";
import Dbfunctions from "../PouchDb/Pouchdb";
import {
  LOCAL_BANK_SET,
  LOCAL_CITY_SET,
  LOCAL_CONTENT_SET,
  LOCAL_MASTER_SET,
  LOCAL_PARTNER_THEME_DATA,
} from "../store/types";
import errorHandler from "./ErrorHandler";

const ExternalFiles = memo(({ getFilesSuccesFull, path, setError }) => {
  var config = window.global?.config;
  var eror = { message: "failed to load component" }
  // appconfig download method
  const getAppconfig = async () => {
    try { 
      //var apConfgurl=`${process.env.REACT_APP_REDIRECT_URL}/${process.env.REACT_APP_NAME}/Appconfig.json`;
	  const res = await fetch(process.env.PUBLIC_URL+`/Appconfig.json`);
      config = await res.json();
      window.global = { config };
      if (config?.version) {
        await checkUpdateVersion(config.version);
      }
      if (config?.dncanalytics) {
        loadDncanalytics(() => { });
      }
      if (config?.adobeanalytics) {
		loadAdobeanalytics(() => { });   
		//var adburl=`${process.env.REACT_APP_REDIRECT_URL}/${process.env.REACT_APP_NAME}/DncAdobeconfig.json`;
		const adoberes = await fetch(process.env.PUBLIC_URL+`/DncAdobeconfig.json`);
        var adobe_object = await adoberes.json();
        window.global = { ...window.global, adobe_object };
      }
      if (config?.applicationDown) {
        var root = document.getElementById("root");
        root.remove();
        var maintainanceEle = document.createElement("div");
        maintainanceEle.innerHTML = config?.downHtml;
        document.body.appendChild(maintainanceEle);
      }
      getFilesSuccesFull(config);
    }
    catch (e) {
      setError(eror)


    }
  };

//adobe analytics file download
  // const loadAdobeanalytics = (callback) => {
  //   try {
  //     const existingScript1 = document.getElementById("adobeanalytics");
  //     if (!existingScript1) {
  //       // const url =  config?.REACT_APP_ENV==="DEV" ?  config?.adobeurl : config?.prodAdobeurl ;
  //       const url =  config?.REACT_APP_ENV==="DEV" ?  config?.oracalurl : config?.oracalurl ; 
  //       const script1 = document.createElement("script");
  //       script1.type = "application/javascript";
  //       script1.src = url;
  //       script1.id = "adobeanalytics";
  //       script1.async = true;
  //       document.head.appendChild(script1);
  //       script1.onload = () => {
  //         if (callback) callback();
  //       };
  //     }
  //     if (existingScript1 && callback) callback();
  //   }
  //   catch (e) {

  //     setError(eror)


  //   }
  // };

const loadAdobeanalytics = (callback, opts = {}) => {
  try {
    if (typeof window === "undefined" || !window.document) {
      console.warn("loadAdobeanalytics: not running in a browser environment.");
      return;
    }
 
    const adobeId = "adobeanalytics";
    const oracleId = "oracleanalytics";
 
    const isDev = config?.REACT_APP_ENV === "DEV";
 
    // Fix oracal/dev/prod URLs here (example)
    const adobeUrl = isDev ? config?.adobeurl : config?.prodAdobeurl;
    //const oracleUrl = isDev ? config?.oracalurl_dev || config?.oracalurl : config?.oracalurl;
     const oracleUrl = isDev ? config?.oracalurl : config?.prodoracalurl;
     const timeoutMs = opts.timeoutMs || 10000; // 10s default timeout
 
    const createOrGetScript = (id, url) => {
      return new Promise((resolve, reject) => {
        // if script exists, try to determine its load state
        let existing = document.getElementById(id);
        if (existing) {
          // If it already has a "data-loaded" flag, resolve immediately
          if (existing.getAttribute("data-loaded") === "true") {
            console.debug(`${id} already loaded`);
            return resolve(existing);
          }
          // else attach handlers to detect when it finishes
          const onExistingLoad = () => resolve(existing);
          const onExistingError = (e) => reject(new Error(`${id} existing script failed to load`));
          existing.addEventListener("load", onExistingLoad, { once: true });
          existing.addEventListener("error", onExistingError, { once: true });
 
          // also guard with a timeout in case events never fire
          setTimeout(() => reject(new Error(`${id} load timeout (existing)`)), timeoutMs);
          return;
        }
 
        // create new script
        const script = document.createElement("script");
        script.type = "application/javascript";
        script.src = url;
        script.id = id;
        script.async = true;
 
        const onLoad = () => {
          script.setAttribute("data-loaded", "true");
          resolve(script);
        };
        const onError = (ev) => {
          reject(new Error(`${id} failed to load from ${url}`));
        };
 
        script.addEventListener("load", onLoad, { once: true });
        script.addEventListener("error", onError, { once: true });
 
        document.head.appendChild(script);
 
        // timeout fallback
        setTimeout(() => {
          if (script.getAttribute("data-loaded") !== "true") {
            reject(new Error(`${id} load timeout (${timeoutMs}ms)`));
          }
        }, timeoutMs);
      });
    };
 
    // load both scripts in parallel and call callback only when both succeed
    Promise.all([
      createOrGetScript(adobeId, adobeUrl),
      createOrGetScript(oracleId, oracleUrl),
    ])
      .then(() => {
        console.info("Analytics scripts loaded");
        if (typeof callback === "function") callback();
      })
      .catch((err) => {
        console.error("Error loading analytics scripts:", err);
        if (typeof setError === "function") setError(err); // if you have a setter
      });
  } catch (error) {
    console.error("Unexpected error in loadAdobeanalytics:", error);
    if (typeof setError === "function") setError(error);
  }
};

  //dnc analytics file download
  const loadDncanalytics = (callback) => {
    try {
      const existingScript = document.getElementById("dncanalytics");
      if (!existingScript) {
        const script = document.createElement("script");
        const dncanalyticsFile  = config?.REACT_APP_ENV==="DEV" ? "dncanalytics-uat.js" : "dncanalytics.js" ;
        script.src = `${path}/${process.env.REACT_APP_NAME}/${dncanalyticsFile}`;
        //script.src = `${path}/${process.env.REACT_APP_NAME}/dncanalytics.js`;
        script.id = "dncanalytics";
        script.type = "text/javascript";
        document.body.appendChild(script);
        script.onload = () => {
          if (callback) callback();
        };
      }
      if (existingScript && callback) callback();
    }
    catch (e) {

      setError(eror)


    }
  };
  const deleteLocalDBData = async () => {
    let masterLocal = localStorage.getItem("masterLocalVer");
    let contentLocal = localStorage.getItem("contentLocalVer");
    let cardTypeLocal = localStorage.getItem("cardTypeLocal");
    let themeLocal = localStorage.getItem("themeLocalVer");
    const currentPath = window.location.pathname.split("/");
    if (currentPath[2] && currentPath[2] !== cardTypeLocal) {
      await Dbfunctions.DeleteSate(LOCAL_CITY_SET);
    }

    if (config?.contentVer !== contentLocal || !contentLocal) {
      await Dbfunctions.DeleteSate(LOCAL_CONTENT_SET);
     
    }
    if (config?.masterVer !== masterLocal || !masterLocal) {
      await Dbfunctions.DeleteSate(LOCAL_MASTER_SET);
      await Dbfunctions.DeleteSate(LOCAL_BANK_SET);
      await Dbfunctions.DeleteSate(LOCAL_CITY_SET);
    }
    localStorage.setItem("masterLocalVer", config.masterVer)
    localStorage.setItem("contentLocalVer", config.contentVer)

    if (config?.themeLocal !== themeLocal || !themeLocal) {
       await Dbfunctions.DeleteSate(LOCAL_PARTNER_THEME_DATA);
    }
    localStorage.setItem("themeLocalVer", config.themeLocal)
  };
  const checkUpdateVersion = async (version) => {
    let localVersion = localStorage.getItem("versionNo");
    let data="testData";
    await Dbfunctions.CreateState( { _id: "CHECK_POUCH_DB",data });
    if (window.isPouchDBAvailable)
    await deleteLocalDBData();
    else {
      localStorage.setItem("masterLocalVer", config.masterVer)
      localStorage.setItem("contentLocalVer", config.contentVer)
      localStorage.setItem("themeLocalVer", config.themeLocal)
    }
    if (localVersion && localVersion !== version) {
      if (caches) {
        // Service worker cache should be cleared with caches.delete()s
        caches.keys().then((cacheNames) => {
          return Promise.all(
            cacheNames.map((cache) => {
              return caches.delete(cache); //Deleting the old cache (cache v1)
            })
          );
        });
      }
      localStorage.setItem("versionNo", version);
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister();
        }
      });
      // delete browser cache and hard reload
      window.location.reload(true);
    } else {
      localStorage.setItem("versionNo", version);
    }

  };

  useEffect(() => {
     if (!window.global?.config) {
      getAppconfig();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
});
export default errorHandler(ExternalFiles);
